import React from 'react';
import Form_Postulacion from '../components/Form_Postulacion';
import './Inscripcion.css'
const Inscripcion = () => {

    return (
        <div className="Inscripcion">

            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdnFuLMoAtcwHVvQoUl_-kDFff61pKbTlT0rC5bMIBJeZepVQ/viewform?embedded=true" width="750px" height="2000" frameborder="0" marginheight="0" scrolling="no" marginwidth="0">Cargando…</iframe>
        </div>
    )
}

export default Inscripcion;

/**<Form_Postulacion></Form_Postulacion> */